export const TRANSLATION_SCOPE = 'accountActions';
